import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ArrowUpRight } from "lucide-react";

export const Footer = ({ settings = {} }) => {
  return (
    <footer data-testid="main-footer" className="grain bg-[#050505] text-white pt-24 pb-10 px-6 md:px-12 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20 border-b border-white/10">
          <div className="md:col-span-6">
            <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[0.95] max-w-xl">
              Let's make something worth holding.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 mt-8 text-lg font-medium link-underline"
            >
              Start a project <ArrowUpRight size={20} />
            </Link>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <p className="font-mono-t text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">Studio</p>
            <ul className="space-y-2 text-zinc-300">
              <li>{settings.contact_address || "Kuala Lumpur, Malaysia"}</li>
              <li><a href={`mailto:${settings.contact_email}`} className="link-underline">{settings.contact_email || "hello@tetralab.my"}</a></li>
              <li>{settings.contact_phone || "+60 3-1234 5678"}</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono-t text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">Social</p>
            <ul className="space-y-2 text-zinc-300">
              <li><a href={settings.instagram || "#"} target="_blank" rel="noreferrer" className="link-underline">Instagram</a></li>
              <li><a href={settings.linkedin || "#"} target="_blank" rel="noreferrer" className="link-underline">LinkedIn</a></li>
              <li><Link to="/admin/login" data-testid="footer-admin-link" className="link-underline text-zinc-500">Admin</Link></li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 pt-8">
          <Logo light />
          <p className="text-zinc-500 text-sm">© {new Date().getFullYear()} TetraLab My. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
